import { render, staticRenderFns } from "./SfxIconHome.vue?vue&type=template&id=7916a622&"
import script from "./SfxIconHome.vue?vue&type=script&lang=js&"
export * from "./SfxIconHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports